import { Component, OnInit, Input, AfterContentInit, ContentChildren, QueryList } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { TemplateDirective } from 'shared';

@Component({
  selector: 'app-page-title-bar',
  templateUrl: './page-title-bar.component.html',
  styleUrls: ['./page-title-bar.component.scss']
})
export class PageTitleBarComponent implements OnInit, AfterContentInit {

  @Input() text: string;

  @ContentChildren(TemplateDirective) innerTemplates: QueryList<TemplateDirective>;

  templates: any = {};

  @Select(s => s.appState.globalConfig.appConfig.breadcrumb)
  breadcrumb$;

  constructor(private store: Store) { }

  ngOnInit() {
  }

  ngAfterContentInit(): void {
    const customContentTemplate = this.innerTemplates.find(temp => temp.getType() == 'custom-content');

    if (customContentTemplate) {
      this.templates.customContent = customContentTemplate.template;
    }

  }

}
